import type { useForm } from "hooks";
import type { BootstrapableForm } from "types";
import type { OnboardingFormProps } from "ui/forms/ECommerce/Onboarding/types";

export const enum FormField {
    HasAdverseMediaCoverage = 'hasAdverseMediaCoverage',
    AdverseMediaCoverageInput = 'adverseMediaCoverageInput',
    HasLegalInvestigation = 'hasLegalInvestigation',
    LegalInvestigationInput = 'legalInvestigationInput',
    HasCertification = 'hasCertification',
    IsCompliantWithTax = 'isCompliantWithTax',
    IsRegisteredWithAuthority = 'isRegisteredWithAuthority',
    RegisteredWithAuthorityInput = 'registeredWithAuthorityInput'
};

export type OnboardingMediaAndComplianceCheck = {
    readonly [FormField.HasAdverseMediaCoverage]: number | null;
    readonly [FormField.AdverseMediaCoverageInput]: string;
    readonly [FormField.HasLegalInvestigation]: number | null;
    readonly [FormField.LegalInvestigationInput]: string;
    readonly [FormField.HasCertification]: number | null;
    readonly [FormField.IsCompliantWithTax]: number | null;
    readonly [FormField.IsRegisteredWithAuthority]: number | null;
    readonly [FormField.RegisteredWithAuthorityInput]: string;
};

export type OnboardingMediaAndComplianceCheckForm = Omit<
    BootstrapableForm<OnboardingMediaAndComplianceCheck, {}>,
    | 'initialValues'
> & {
    readonly initialValues: OnboardingMediaAndComplianceCheck;
};

export type OnboardingMediaAndComplianceCheckProps =
    & OnboardingFormProps
    & OnboardingMediaAndComplianceCheckForm
    & ReturnType<typeof useForm<OnboardingMediaAndComplianceCheck>>;
